import './pageNotFound.scss';

const PageNotFound = () => {

    return (
        <div className="page-not-found">
            <h1>404</h1>
            <p>Page not found</p>
        </div>
    );
}

export default PageNotFound;